import { ENTITY_TAG_VALUES, type EntityTagValue } from '../../../components/CustomWorkflows/entityTags'

export const WORKFLOW_PARAM = 'workflow'
export const ENTITY_PARAM = 'entity'

export interface RunFiltersValue {
  workflowId: string | null
  entity: EntityTagValue | null
}

export const NO_RUN_FILTERS: RunFiltersValue = { workflowId: null, entity: null }

export const parseEntity = (raw: string | null): EntityTagValue | null => ENTITY_TAG_VALUES.find((value) => value === raw) ?? null

export const readRunFilters = (params: URLSearchParams): RunFiltersValue => ({
  workflowId: params.get(WORKFLOW_PARAM) || null,
  entity: parseEntity(params.get(ENTITY_PARAM)),
})

export const writeRunFilters = (params: URLSearchParams, { workflowId, entity }: RunFiltersValue): URLSearchParams => {
  const next = new URLSearchParams(params)
  for (const [key, value] of [
    [WORKFLOW_PARAM, workflowId],
    [ENTITY_PARAM, entity],
  ] as const) {
    if (value) {
      next.set(key, value)
    } else {
      next.delete(key)
    }
  }
  return next
}
